import React from "react";
import PropTypes from "prop-types";
import {  useSelector } from "react-redux";
import { faBell as faBellRegular } from "@fortawesome/pro-regular-svg-icons";
import { Badge } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";

export const NotificationsBadge = ({ active, exist, onClick }) => {  
  const main = useSelector(state => state.main);
  return (
    <div className={"notification-drawer-icon-container" + (active ? " active" : "") + (main.myType === "STUDIO" ? " type-studio" : "")} 
      onClick={() =>{ 
        onClick();
      }}>
      <Badge dot={exist}>
        <FontAwesomeIcon icon={faBellRegular} className={"notification-drawer-icon" + (main.myType !== "STUDIO" ? " type-not-studio" : "")} />
      </Badge>
    </div>
  );
};

NotificationsBadge.propTypes = {
  active: PropTypes.bool.isRequired,
  exist: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default NotificationsBadge;
